import { MapRow } from "./MapRow";



/**
 * Sekce herni mapy se sklada z jednotlivych radku
 */
export class MapSection {
    /**
     * (RO) UID sekce
     */
    get uid(): string { return this._uid; }
    private _uid: string;

    /**
     * (RO) Radky tvorici sekci. Prazdna radka = undefined
     */
    get rows(): MapRow[] { return this._rows; }
    private _rows: MapRow[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(uid: string, rows: MapRow[]) {
        this._uid = uid;
        this._rows = rows;
    }
}